import angular from 'angular';
import customerCareLockedView from './customerCareLockedView';

export default angular
  .module('components.customerCareLockedView', [])
  .component('customerCareLockedView', customerCareLockedView).name;
